import script from "./unfinished-order-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./unfinished-order-list.vue?vue&type=script&lang=tsx&setup=true"

import "./unfinished-order-list.vue?vue&type=style&index=0&id=4510826f&lang=scss"

const __exports__ = script;

export default __exports__